GatorSurvey.app.directive("gsButtonSelectQuestion", ['surveyResponseService', GsButtonSelectQuestion]);
function GsButtonSelectQuestion(surveyResponseService) {
    return {
        restrict: 'AE',
        scope: {
            gsModel: "=ngModel",
            mode: "=?"
        },
        templateUrl: 'Assets/Scripts/App/Directives/Questions/Templates/ButtonSelectQuestionLive.html',
        controller: ['$scope', function ($scope) {

            $scope.SelectedButton = "";
            $scope.isTest = getUrlParameter("t") !== "1";
            $scope.getId = function(item) {
                return isTest ? item.tempId : item.id;
            };
            $scope.ChangeActive = function (item) {
                $scope.SelectedButton = isTest ? item.tempId : item.id;
                surveyResponseService.updateResponseQuestion($scope.gsModel, $scope.SelectedButton);
            };
            
            surveyResponseService.AddNewQuestion($scope.gsModel,
                function(response) {
                    $scope.SelectedButton = response.answer;
                });
            
            $scope.activeStylingId = GatorSurvey.models.guid();



        }]
    };
}